<template>
    <v-overlay v-show="show">
        <v-card light max-width="95vw">
            <v-card-title>
                <v-row>
                    <v-col class="py-0">수동항목처리</v-col>
                    <v-col cols="auto" class="py-0"><v-icon @click="close">mdi-close</v-icon></v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="items" disable-sort hide-default-footer>
                    <template v-slot:[`item.manual.wiredAt`]="{ item }">
                        <v-datetime-field v-model="item.manual.wiredAt" @input="setSave(item)" :label="null" :hideDetails="false" padding="0 0" />
                    </template>
                    <template v-slot:[`item.manual.amount`]="{ item }">
                        <v-text-field v-model="item.manual.amount" @input="setSave(item)" type="number" />
                    </template>
                    <template v-slot:[`item.manual.type`]="{ item }">
                        <v-select v-model="item.manual.type" :items="types" @input="setSave(item)" />
                    </template>
                    <template v-slot:[`item.manual.message`]="{ item }">
                        <v-text-field v-model="item.manual.message" @input="setSave(item)" />
                    </template>
                    <template v-slot:[`item.commissionPercentage`]=""> {{ commissionPercentage }}% </template>
                    <template v-slot:[`item.manual.settlement.amount`]="{ item }">
                        <v-text-field v-model="item.manual.settlement.amount" @input="setSave(item)" type="number" />
                    </template>
                    <template v-slot:[`item.manual.settlement.commission`]="{ item }">
                        <v-text-field v-model="item.manual.settlement.commission" @input="setSave(item)" type="number" />
                    </template>
                    <template v-slot:[`item.manual.settlement.settledAt`]="{ item }">
                        <v-row align="center">
                            <v-col cols="auto" class="py-0">
                                <v-switch v-model="item.isSettled" @change="setSettlement(item)" />
                            </v-col>
                            <v-col class="py-0">
                                <template v-if="!item.isSettled">미정산</template>
                                <v-datetime-field v-show="item.isSettled" v-model="item.manual.settlement.settledAt" @input="setSave(item)" :label="null" :hideDetails="false" padding="0 0" />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon @click="remove(item)" color="red">mdi-minus-circle</v-icon>
                        <v-icon @click="save([item])" :disabled="!item.manual.save" color="primary" class="ml-2">mdi-content-save</v-icon>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-row justify="center">
                    <v-col cols="auto">
                        <v-btn @click="add" color="secondary">항목추가<v-icon class="ml-2">mdi-plus-circle</v-icon></v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn @click="save(items)" :disabled="!hasSave" color="primary">일괄저장하기<v-icon class="ml-2">mdi-content-save</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-overlay>
</template>

<script>
import api from "@/api";
import vDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";
import dayjs from "dayjs";

export default {
    components: { vDatetimeField },
    props: {
        value: Object,
        payments: Array,
        commissionPercentage: String,
    },

    data() {
        return {
            show: false,
            items: [],
            headers: [
                { text: "입금일", value: "manual.wiredAt", width: 260 },
                { text: "입금액", value: "manual.amount", width: 160 },
                { text: "적요", value: "manual.message", width: 160 },
                { text: "결제형태", value: "manual.type", width: 160 },
                { text: "정산수수료율", value: "commissionPercentage", width: 110 },
                { text: "정산금액", value: "manual.settlement.amount", width: 160 },
                { text: "정산수수료", value: "manual.settlement.commission", width: 160 },
                { text: "정산완료", value: "manual.settlement.settledAt", width: 260 },
                { text: "actions", value: "actions", width: 100 },
            ],
            types: ["가상계좌", "카드", "무통장입금"],
            isDones: [
                { text: "미정산", value: false },
                { text: "정산완료", value: false },
            ],
        };
    },
    computed: {
        hasSave() {
            return this.items.some(({ manual: { save } }) => save);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        open() {
            this.show = true;
            this.init();
        },
        close() {
            this.show = false;
        },
        init() {
            this.items = JSON.parse(JSON.stringify(this.payments.filter(({ isManual }) => isManual)));
        },
        add() {
            this.items.push({
                isSettled: false,
                manual: {
                    wiredAt: null,
                    amount: "",
                    message: "",
                    type: "",
                    settlement: {
                        amount: 0,
                        commission: 0,
                        settledAt: null,
                    },
                    save: true,
                },
            });
        },
        setSave(target) {
            const item = this.items.find((item) => item == target);
            if (!item.manual.save) item.manual.save = true;
        },
        setSettlement(target) {
            const item = this.items.find((item) => item == target);
            if (!item.manual.save) item.manual.save = true;
            if (item.isSettled) item.manual.settlement.settledAt = Date.now().toDateTime();
            else item.manual.settlement.settledAt = null;
        },
        async remove(target) {
            try {
                if (target._id) {
                    await api.console.contracts.payments.delete({ _contract: this.value._id, _payment: target._id });
                    Object.assignDefined(this.value, {
                        _payments: this.value._payments.filter((_payment) => _payment !== target._id),
                        payments: this.value.payments.filter(({ _id }) => _id !== target._id),
                    });
                    alert("변경사항이 저장되었습니다");
                    this.$nextTick(() => this.init());
                } else this.items = this.items.filter((item) => item !== target);
            } catch (error) {
                this.handleError(error);
            }
        },
        async save(items) {
            try {
                await this.post(items.filter(({ _id, manual }) => !_id && manual.save));
                await this.put(items.filter(({ _id, manual }) => _id && manual.save));
                alert("변경사항이 저장되었습니다");
                this.init();
            } catch (error) {
                this.handleError(error);
            }
        },
        async post(items) {
            const payments = await Promise.all(items.map(async (payment) => (await api.console.contracts.payments.post({ ...payment, _contract: this.value._id })).payment));

            if (payments?.length)
                Object.assignDefined(this.value, {
                    _payments: [...this.value._payments, ...payments.map(({ _id }) => _id)],
                    payments: [...this.value.payments, ...payments],
                });
        },
        async put(items) {
            const payments = await Promise.all(items.map(async (payment) => (await api.console.contracts.payments.put({ ...payment, _contract: this.value._id, _payment: payment._id })).payment));

            if (payments?.length)
                payments.forEach((payment) =>
                    Object.assignDefined(
                        this.value.payments.find(({ _id }) => _id == payment._id),
                        payment
                    )
                );
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
};
</script>

<style></style>
